import { render } from "./UseRequest.vue?vue&type=template&id=17f06009"
import script from "./UseRequest.vue?vue&type=script&lang=js"
export * from "./UseRequest.vue?vue&type=script&lang=js"

import "./UseRequest.vue?vue&type=style&index=0&id=17f06009&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__